import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_WORKSPACE_PREBID_MODULE_ENABLED: TypedDocumentNode<Data, { input: Variables }> =
  gql`
    ${ERROR_FRAGMENT}

    mutation updateWorkspacePrebidModuleEnabled($input: UpdateWorkspacePrebidModuleEnabledInput!) {
      updateWorkspacePrebidModuleEnabled(input: $input) {
        errors {
          ...ErrorFragment
        }
      }
    }
  `
